import React from "react"
import { Heading, Section } from "ui"
import Layers from "../Layers"

const LayersPane = props => {
    return (
        <Section margin="none" paddingTop="none">
            <Heading size="small">Layers</Heading>
            <div style={{ overflowX: "auto" }}>
                <Layers onSelectBlock={props.close} />
            </div>
        </Section>
    )
}
export default LayersPane



// WEBPACK FOOTER //
// ./src/features/editor/sidebars/LayersPane.js